/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivFleetVehicleControllerGetAllParamsGen,
  MrfiktivFleetVehicleControllerGetAllPostParamsGen,
  MrfiktivFleetVehicleViewModelGen,
  MrfiktivMultipleIdsDtoOptionalGen,
  MrfiktivPageViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class FleetVehicles<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Fleet Vehicles
   * @name FleetVehicleControllerGetAll
   * @summary (VEHICLE-READ) Get all vehicles
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/vehicle
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivFleetVehicleViewModelGen)[] })`
   */
  fleetVehicleControllerGetAll = (
    { partnerId, fleetId, ...query }: MrfiktivFleetVehicleControllerGetAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivFleetVehicleViewModelGen[] }, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/vehicle`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Vehicles
   * @name FleetVehicleControllerGetAllPost
   * @summary (FLEET-VEHICLE-READ) Get all vehicles
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/vehicle
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivFleetVehicleViewModelGen)[] })`
   */
  fleetVehicleControllerGetAllPost = (
    { partnerId, fleetId, ...query }: MrfiktivFleetVehicleControllerGetAllPostParamsGen,
    data: MrfiktivMultipleIdsDtoOptionalGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivFleetVehicleViewModelGen[] }, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/vehicle`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Vehicles
   * @name FleetVehicleControllerGetOne
   * @summary (VEHICLE-READ) Get a vehicle by vehicleId
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/vehicle/{vehicleId}
   * @secure
   * @response `201` `MrfiktivFleetVehicleViewModelGen` Get a vehicle by vehicleId
   */
  fleetVehicleControllerGetOne = (partnerId: string, fleetId: string, vehicleId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetVehicleViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/vehicle/${vehicleId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
